module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-225.f908f8ab.svg";